'use strict';

var log = require('../../log/Log').channel('RemoteControlService');
var sutl = require('../../sutl/Sutl');

angular.module('inara').factory('RemoteControlService', [
    '$rootScope',
    'KayleeService',
    'RoomService',
    function ($rootScope, KayleeService, RoomService) {
        var room = null;
        var site = null;
        var remoteCode = null;
        var remoteCodePieces = [];
        var remoteCodePieceLength = 4;
        var remoteControlSessions = null;
        var myRemoteControlSessionId = null;

        log.info('initializing');

        RoomService.onOnlineChanged(onRoomOnlineChanged);

        $rootScope.$on('$destroy', function () {
            RoomService.offOnlineChanged(onRoomOnlineChanged);
            removeCallbacks();
        });

        return {
            getMyRemoteControlSessionId: getMyRemoteControlSessionId,
            getRemoteControlCode: getRemoteControlCode,
            getRemoteControlSessions: getRemoteControlSessions,
            getRemoteControlUrl: getRemoteControlUrl,
            remoteControlCodeVisible: remoteControlCodeVisible,
            remoteControlUsersVisible: remoteControlUsersVisible,
        };

        function getMyRemoteControlSessionId() {
            return myRemoteControlSessionId;
        }

        function getRemoteControlCode() {
            var code = sutl.getNode(room, ['remoteControl', 'code'], null);
            if (code !== remoteCode) {
                remoteCode = code;
                var pieces = [];
                if (code !== null) {
                    // split into pieces 4 elements long
                    while (code.length > 0) {
                        pieces.push(code.slice(0, remoteCodePieceLength));
                        code = code.substring(remoteCodePieceLength);
                    }
                }
                remoteCodePieces = pieces;
            }
            return remoteCodePieces;
        }

        function getRemoteControlSessions() {
            return remoteControlSessions;
        }

        function getRemoteControlUrl() {
            if (KayleeService.getAlias() === null) return null;
            return KayleeService.getRemoteAuthUrl() + '/?code=' + remoteCode;
        }

        function onRoomOnlineChanged(online) {
            if (online) {
                room = RoomService.getRoom();
                site = KayleeService.getSite(room.siteId);
                remoteControlSessions = room.$getRemoteControlSessions();
                remoteControlSessions.$getThisSessionId().then(function (sessionId) {
                    myRemoteControlSessionId = sessionId;
                });
            } else {
                removeCallbacks();
                myRemoteControlSessionId = null;
            }
        }

        function remoteControlCodeVisible() {
            return (
                site &&
                site.$isLoaded() &&
                sutl.getNode(site, 'settings.remoteControlEnabled') === true &&
                KayleeService.isConnected() &&
                ((KayleeService.isAuthenticatedAsUser() &&
                    !KayleeService.isAuthenticatedAsAnonymousRemoteControl()) ||
                    KayleeService.isAuthenticatedAsController())
            );
        }

        function remoteControlUsersVisible() {
            if (!remoteControlSessions) return false;
            var sessionCount = remoteControlSessions.filter(function (session) {
                return session.expires > Date.now();
            }).length;
            return KayleeService.isConnected() && sessionCount > 0;
        }

        function removeCallbacks() {
            remoteControlSessions = null;
            room = null;
            site = null;
        }
    },
]);
